import { useTheme } from 'styled-components';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalContext,
  Text,
  toast,
  useServerResponseTranslation,
} from 'dash-ui';

import { BrokerModals } from 'pages/brokers/constants/constants';
import {
  GetBrokerByIdDocument,
  GetBrokersDocument,
  useUnblockBrokerMutation,
} from 'gql/generated.graphql';

const UnblockBrokerModal = () => {
  const { t } = useTranslation(['pages', 'common', 'forms']);
  const translateErrorMessage = useServerResponseTranslation();
  const theme = useTheme();

  const { isOpenCurrent, toggleModal, payload, setPayload } =
    useContext(ModalContext);

  const isOpen = isOpenCurrent[BrokerModals.UNBLOCK_BROKER_MODAL];

  const [unblockBroker, { loading }] = useUnblockBrokerMutation({
    refetchQueries: [GetBrokersDocument, GetBrokerByIdDocument],
  });

  const closeModal = () => {
    toggleModal(false, BrokerModals.UNBLOCK_BROKER_MODAL);
    setPayload(null);
  };

  const onSubmit = () => {
    unblockBroker({ variables: { brokerId: payload?.brokerId } })
      .then(() => {
        closeModal();
      })
      .catch((error) => {
        toast.error(translateErrorMessage(error));
      });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      submitButton={{
        disabled: loading,
        isLoading: loading,
        title: t('common:labels.confirm'),
        colorVariation: 'danger',
        onClick: onSubmit,
      }}
      cancelButton={{
        title: t('common:labels.cancel'),
        onClick: closeModal,
      }}
    >
      <Text bold xl>
        {t('pages:brokersPage.unblockBroker')}
      </Text>
      <Text color={theme.colors.n80}>
        {t('pages:brokersPage.modals.unblockBrokerSubtitle')}
      </Text>
    </Modal>
  );
};

export default UnblockBrokerModal;
